import { FormInputField } from '../../contracts/form-input-field.js';
import { IDataWithLocalizedRichDescription, IDataWithLocalizedTitle } from '../../contracts/localized-data.js';
import { DataModelBuilder, isSameData, isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedRichDescription } from '../../models/serializable/localized-rich-description.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';

export class FormComponent extends RenderableComponent
  implements IDataWithLocalizedTitle, IDataWithLocalizedRichDescription {
  static readonly TYPE_ID: string = 'aae52921419b4da5931b794a0c1f3aaf';
  static readonly DEFAULT_RENDER_ORDER: number = 18;

  constructor(
    public readonly titles: LocalizedString,
    public readonly richDescriptions: LocalizedRichDescription,
    public readonly isRenderingEnabled: boolean,
    public readonly renderOrder: number,
    public readonly formFields: FormInputField[],
    public readonly destinationEmail: string,
  ) {
    super();
  }

  get $typeId(): string {
    return FormComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FormComponent {
    return new FormComponent(
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'titles')),
        context.fromData<LocalizedRichDescription>(MapUtils.get<SerializedData>(map, 'richDescriptions')),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.getList<FormInputField>(map, 'formFields', (value) =>
          context.fromData<FormInputField>(value as SerializedData),
        ),
        MapUtils.get<string>(map, 'destinationEmail'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'titles': context.toData(this.titles),
      'richDescriptions': context.toData(this.richDescriptions),
      'isRenderingEnabled': this.isRenderingEnabled,
      'renderOrder': this.renderOrder,
      'formFields': this.formFields.map((e) => context.toData(e)),
      'destinationEmail': this.destinationEmail,
    };
  }

  clone(): this {
    return new FormComponent(
        this.titles.clone(),
        this.richDescriptions.clone(),
        this.isRenderingEnabled,
        this.renderOrder,
        this.formFields.map((e) => e.clone()),
        this.destinationEmail,
    ) as this;
  }

  isSame(other: FormComponent): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.titles, this.titles) &&
      isSameData(other.richDescriptions, this.richDescriptions) &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled &&
      isSameList(other.formFields, this.formFields, isSameData) &&
      other.destinationEmail == this.destinationEmail;
  }
}

export class FormComponentBuilder extends DataModelBuilder<FormComponent> {
  build(context: SerializationContext, map: SerializedData): FormComponent {
    return FormComponent.fromMap(context, map);
  }
}
